"use client"

import { useState } from "react"
import { Menu } from "lucide-react"
import Navbar from "./navbar"
import NavbarProfileSection from "./navbarProfileSection"
import NavbarBasket from "./navbarBasket"
import NavbarLanguageSwitcher from "./navbarLanguageSwitcher"
import { Button } from "@/components/ui/button"
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet"
import { Link, useRouteLoaderData } from "react-router-dom"
import { useTranslation } from "react-i18next"

type RootLoaderData = {
    isAuthenticated: boolean;
    userName: string | null;
    userRoles: string[] | null;
};

const NavbarLayout = () => {
    const { t } = useTranslation()
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    const { isAuthenticated, userName, userRoles } = useRouteLoaderData("root") as RootLoaderData;

    return (
        <nav className="flex items-center justify-between gap-2 px-4">
            {/* Mobile Menu & Desktop Navbar */}
            <div className="flex items-center gap-2">
                {/* Mobile Menu */}
                <Sheet open={isMenuOpen} onOpenChange={setIsMenuOpen}>
                    <SheetTrigger asChild>
                        <Button variant="ghost" size="icon" className="md:hidden" onClick={() => setIsMenuOpen(true)}>
                            <Menu className="h-5 w-5" />
                            <span className="sr-only">Open menu</span>
                        </Button>
                    </SheetTrigger>
                    <SheetContent side="left" className="w-80">
                        <div className="mt-6">
                            <Navbar userRoles={userRoles} isMobile={true} onNavigate={() => setIsMenuOpen(false)} />
                        </div>
                    </SheetContent>
                </Sheet>

                {/* Desktop Navbar */}
                <div className="hidden md:block">
                    <Navbar userRoles={userRoles} isMobile={false} />
                </div>
            </div>

            {/* Right Side Actions */}
            <div className="flex items-center gap-2 sm:gap-2">
                {/* Language Switcher */}
                <NavbarLanguageSwitcher />

                {isAuthenticated ? (
                    <>
                        {/* Basket */}
                        <div className="hidden sm:block">
                            <NavbarBasket />
                        </div>
                        <div className="sm:hidden">
                            <NavbarBasket />
                        </div>

                        {/* Profile */}
                        <div className="hidden sm:block">
                            <NavbarProfileSection userName={userName!} />
                        </div>
                        <div className="sm:hidden">
                            <NavbarProfileSection userName={userName!} />
                        </div>
                    </>
                ) : (
                    <div className="flex items-center gap-2">
                        <Link to="/login">
                            <Button variant="ghost" size="sm">{t("auth.login")}</Button>
                        </Link>
                        <Link to="/register">
                            <Button size="sm">{t("auth.register")}</Button>
                        </Link>
                    </div>
                )}
            </div>
        </nav>
    )
}

export default NavbarLayout
